const containerCls = "_n29c1txvwm";
const imageWrapperCls = "_n29i1q08qaz";
const contextMenu = "_n29chorc0h";
const imageCls = "_n29iofgw7";
const creditingCls = "_n29cf214e0";

export { containerCls, contextMenu, creditingCls, imageCls, imageWrapperCls };
import "./Image.style.linaria.module.css";
//# sourceMappingURL=Image.style.js.map
